'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConditional = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createConditional = exports.createConditional = function createConditional(_ref) {
  var displayName = _ref.displayName,
      propTypes = _ref.propTypes,
      shouldShow = _ref.shouldShow,
      shouldHide = _ref.shouldHide;

  var Conditional = function (_React$Component) {
    _inherits(Conditional, _React$Component);

    function Conditional(props, context) {
      _classCallCheck(this, Conditional);

      var _this = _possibleConstructorReturn(this, (Conditional.__proto__ || Object.getPrototypeOf(Conditional)).call(this, props, context));

      var value = (0, _utils.getContextValue)(context, props.channel);

      _this.state = {
        visible: shouldShow(props, value)
      };

      if (_this.state.visible && props.onEnter) {
        props.onEnter();
      }
      return _this;
    }

    _createClass(Conditional, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var value = (0, _utils.getContextValue)(nextContext, nextProps.channel);

        if (!this.state.visible && shouldShow(nextProps, value)) {
          this.setState({
            visible: true
          });

          if (nextProps.onEnter) {
            nextProps.onEnter();
          }
        }

        if (this.state.visible && shouldHide(nextProps, value)) {
          this.setState({
            visible: false
          });

          if (nextProps.onLeave) {
            nextProps.onLeave();
          }
        }
      }
    }, {
      key: 'render',
      value: function render() {
        if (typeof this.props.render === 'function') {
          return this.props.render(this.state.visible);
        }

        return this.state.visible ? this.props.children : null;
      }
    }]);

    return Conditional;
  }(_react2.default.Component);

  Conditional.displayName = displayName;

  Conditional.contextTypes = {
    automata: _propTypes2.default.object
  };

  Conditional.propTypes = _extends({}, propTypes, {
    channel: _propTypes2.default.string,
    children: _propTypes2.default.node,
    render: _propTypes2.default.func,
    onEnter: _propTypes2.default.func,
    onLeave: _propTypes2.default.func
  });

  Conditional.defaultProps = {
    children: null
  };

  return Conditional;
};

exports.default = createConditional;


//////////////////
// WEBPACK FOOTER
// ./~/react-automata/lib/createConditional.js
// module id = 479
// module chunks = 168707334958949